import React from 'react';

const SIZE_CLASS = {
  sm: 'h-8 w-8 border-2',
  md: 'h-10 w-10 border-2',
  lg: 'h-12 w-12 border-2',
  xl: 'h-12 w-12 border-b-2',
};

/**
 * Brand-consistent loading indicator (orange accent).
 */
export default function AppSpinner({ size = 'md', className = '' }) {
  const dim = SIZE_CLASS[size] || SIZE_CLASS.md;
  const ring = size === 'xl' ? 'border-orange-600' : 'border-slate-200 dark:border-slate-700 border-t-orange-600';

  return (
    <div
      className={`animate-spin rounded-full ${dim} ${ring} ${className}`}
      role="status"
      aria-label="Loading"
    />
  );
}
